import React from 'react';

interface StoryCardPreviewProps {
  title: string;
  coverEmoji?: string | null;
  coverGradient: string;
  cardTextColor: string;
  status?: 'draft' | 'published' | 'archived';
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: { w: 80, h: 120, emoji: 28, title: 11 },
  md: { w: 110, h: 160, emoji: 36, title: 13 },
  lg: { w: 140, h: 200, emoji: 44, title: 15 },
};

/**
 * Карточка-превью для дашборда — отражает то, как story будет выглядеть в карусели.
 * Используется в списке и в шапке edit-страницы.
 */
const StoryCardPreview: React.FC<StoryCardPreviewProps> = ({
  title,
  coverEmoji,
  coverGradient,
  cardTextColor,
  status,
  size = 'md',
}) => {
  const s = sizeMap[size];
  return (
    <div
      className="relative rounded-2xl overflow-hidden shadow-md flex flex-col justify-between"
      style={{
        width: s.w,
        height: s.h,
        background: coverGradient || 'linear-gradient(135deg, #999 0%, #555 100%)',
        color: cardTextColor || '#FFFFFF',
      }}
    >
      {status && status !== 'published' && (
        <div className="absolute top-1.5 right-1.5 px-1.5 py-0.5 text-[9px] uppercase tracking-wide rounded-full bg-black/40 text-white">
          {status === 'draft' ? 'draft' : 'archived'}
        </div>
      )}
      <div className="p-2 flex justify-start items-start" style={{ fontSize: s.emoji, lineHeight: 1 }}>
        <span>{coverEmoji || ''}</span>
      </div>
      <div
        className="p-2 font-semibold leading-tight"
        style={{ fontSize: s.title, color: cardTextColor || '#FFFFFF' }}
      >
        {title || 'Без заголовка'}
      </div>
    </div>
  );
};

export default StoryCardPreview;
